const ShopProductCategory = () => import(/* webpackChunkName: "ShopProductCategory" */ './ShopProductCategory');
const ShopProductByCategoryV2 = () => import(/* webpackChunkName: "ShopProductCategoryV2" */ './ShopProductByCategoryV2');
export default [
  {
    path: '/shop/all-hair-color',
    name: 'ShopAllHairColor',
    component: ShopProductByCategoryV2,
    meta: {
      noScroll: true
    },
    props: true,
    scrollBehavior(to) {
      // allow scroll to anchor
      if (to.hash) {
        return {
          selector: to.hash
        };
      }
    }
  },
  {
    path: '/shop/:keyA/:keyB?/:keyC?/:keyD?/:keyE?',
    name: 'ShopProductCategory',
    component: ShopProductCategory,
    meta: {
      noScroll: true
    },
    props: true,
    scrollBehavior(to) {
      // allow scroll to anchor
      if (to.hash) {
        return {
          selector: to.hash
        };
      }
    }
  },
];
